// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Firebase Configurations
const firebaseConfigSC = {
  apiKey: "AIzaSyBMkCaHEBUte2-_s6s5ZFR1dlpJctnGMtM",
  authDomain: "cachet-blinds.firebaseapp.com",
  projectId: "cachet-blinds",
  storageBucket: "cachet-blinds.appspot.com",
  messagingSenderId: "272860659402",
  appId: "1:272860659402:web:510c91f9e8ab6cb448be33",
  measurementId: "G-ZY89KEE7BC",
};

const firebaseConfigDP = {
  apiKey: "AIzaSyBMkCaHEBUte2-_s6s5ZFR1dlpJctnGMtM",
  authDomain: "cachet-blinds.firebaseapp.com",
  projectId: "cachet-blinds",
  storageBucket: "cachet-blinds.appspot.com",
  messagingSenderId: "272860659402",
  appId: "1:272860659402:web:510c91f9e8ab6cb448be33",
  measurementId: "G-ZY89KEE7BC",
};

// Initialize Firebase Apps with Names
const appSC = initializeApp(firebaseConfigSC, "SC_App");
const appDP = initializeApp(firebaseConfigDP, "DP_App");

// Export Firestore and Auth for SC App (matches expo app)
export const db = getFirestore(appSC);
export const auth = getAuth(appSC);

// Also export for DP App if needed
export const dbDP = getFirestore(appDP);
export const authDP = getAuth(appDP);

// Cloud Functions for SC App
const functions = getFunctions(appSC);

// Connect Functions Emulator (if in development)
if (window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// Export Callable Cloud Functions
export const sendEmail = httpsCallable(functions, "sendEmail", {
  timeout: 70000, // 30 seconds
});